<template lang="pug">
    v-form.c-form(autocomplete="off" @submit.prevent="submit")

        // Email field
        v-text-field(
            type="email"
            name="email"
            :label="$t('fields.email')"
            :class="{ 'input-group--dirty': dirtyEmail }"
            v-model.lazy="model.email"
            v-validate="'required|email'"
            :data-vv-as="$t('fields.email')"
            :error-messages="errors.collect('email')"
            autocomplete="off"
            outline
        )

        // Password field
        v-text-field(
            name="password"
            :type="visibility ? 'text' : 'password'"
            :label="$t('fields.password')"
            :class="{ 'input-group--dirty': dirtyPwd }"
            v-model.lazy="model.password"
            v-validate="'required|min:6|max:24'"
            :data-vv-as="$t('fields.password')"
            :error-messages="errors.collect('password')"
            :append-icon="visibility ? 'visibility' : 'visibility_off'"
            autocomplete="off"
            outline
            @click:append="() => (visibility = !visibility)"
        )

        div
            // Submit button
            button-component.mx-0.submit(
                large
                type="submit"
                color="primary"
                size="medium"
                :action="submit"
                :isLoading="isLoading"
            ) {{ $t('auth.login.button') }}


        div.full-width
            separator-component

        div.linksWrapper.mt-2
            div

                // Redirect to reset password page
                router-link.link(a to="/forgot-password") {{ $t('auth.login.link') }}

            div(v-if="!hideRegistration")

                // Sign Up link
                router-link.link(
                    tag="a"
                    to="/subscriptions"
                ) {{ $t('auth.login.signUpNow') }}
</template>

<script>
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import { isAndroid } from '~services';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        data() {
            return {
                model: {
                    email: null,
                    password: null
                },
                interval: null,
                dirtyEmail: null,
                dirtyPwd: null,
                visibility: false
            };
        },
        computed: {
            ...mapGetters('auth', ['isLoading']),

            // Google Play requires Google Play Billing for any in-app
            // purchase flow. We have none, so hide the sign-up (which leads
            // to paid subscriptions) on the Android app to satisfy policy.
            hideRegistration() {
                return isAndroid();
            }
        },
        mounted() {
            let times = 0;
            this.interval = setInterval(() => {
                times += 1;
                if ((this.dirtyEmail && this.dirtyPwd) || times === 20) {
                    clearInterval(this.interval);
                }
                this.dirtyEmail = document.querySelector(
                    'input[type="email"]:-webkit-autofill'
                );
                this.dirtyPwd = document.querySelector(
                    'input[type="password"]:-webkit-autofill'
                );
            }, 100);

            const dict = {
                custom: {
                    email: {
                        email: 'Invalid Email',
                        required: 'Email field is required'
                    },
                    password: {
                        required: 'Password field is required',
                        min: 'Your Password must be at least 8 characters.',
                        max:
                            'Your Password may not be greater than 24 characters'
                    }
                }
            };

            this.$validator.localize('en', dict);
        },
        methods: {
            ...mapActions('auth', ['login']),

            /**
             * Login user on submit
             * @returns {boolean}
             */
            async submit() {
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                this.login(this.model);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .controls
        display: flex
        justify-content: space-between
        align-items: center
        flex-direction: row

        div
            width: calc(50% - 10px)

    .submit
        width: 100%

    .linksWrapper
        width: 100%
        display: flex
        justify-content: space-between
        align-items: center

    .link
        font-size: 14px
</style>
